import { RequestParameters } from '../types';
import { useMutation, UseMutationOptions, useQuery } from 'react-query';
import { createReferral, checkReferral, CreateReferralPayload, getReferrals, updateReferral } from './api.ts';

export enum ReferralHook {
  Referrals = 'referrals',
}

export function useReferrals(params: RequestParameters) {
  return useQuery([ReferralHook.Referrals, params], () => getReferrals(params));
}

export function useUpdateReferralMutation(options: UseMutationOptions<unknown, unknown, Record<string, any>>) {
  return useMutation((data: Record<string, any>) => updateReferral(data), options);
}

export function useCheckReferralMutation(
  options: UseMutationOptions<unknown, unknown, { agreement: number; document: string }>
) {
  return useMutation((payload: { agreement: number; document: string }) => checkReferral(payload), options);
}

export function useCreateReferralMutation(options: UseMutationOptions<unknown, unknown, CreateReferralPayload>) {
  return useMutation((payload: CreateReferralPayload) => createReferral(payload), options);
}

